import axios from 'axios';
import { serverConfig } from '../server-config';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Auth token has expired or is invalid, delete it from local storage
      localStorage.removeItem('authToken');
      location.reload();
    }
    return Promise.reject(error);
  }
);

export const ClientDashboardService = {
  fetchDashboardData: async (clientId) => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/client/dashboard/load/${clientId}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  fetchShortlistAnalytics: async (clientId, date) => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/client/dashboard/shortlist-analytics?clientId=${clientId}&date=${date}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },
};
